import { render, staticRenderFns } from "./IcoBadgeBtn.vue?vue&type=template&id=eb82baf4&"
import script from "./IcoBadgeBtn.vue?vue&type=script&lang=ts&"
export * from "./IcoBadgeBtn.vue?vue&type=script&lang=ts&"
import style0 from "./IcoBadgeBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBadge,VBtn})
